module.exports = __webpack_public_path__ + "static/media/14UNEP24.cb3cb002.jpg";